import { render } from "./top-banner.vue?vue&type=template&id=db1072da&ts=true"
import script from "./top-banner.vue?vue&type=script&lang=ts"
export * from "./top-banner.vue?vue&type=script&lang=ts"

import "./top-banner.vue?vue&type=style&index=0&id=db1072da&lang=css"

import exportComponent from "C:\\Users\\claus\\source\\repos\\Joni\\SelfService\\JoniSelfService\\JoniSelfServicePortalUI\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__